import { AutoMap } from '@automapper/classes';
import { IsDefined, IsNotEmpty, IsString, IsUUID } from 'class-validator';

export class UserDto {
  @AutoMap()
  @IsDefined()
  @IsNotEmpty()
  @IsUUID()
  id: string;

  @AutoMap()
  @IsDefined()
  @IsString()
  @IsNotEmpty()
  username: string;

  @AutoMap()
  @IsDefined()
  @IsString()
  @IsNotEmpty()
  firstName: string;

  @AutoMap()
  @IsDefined()
  @IsString()
  @IsNotEmpty()
  lastName: string;

  @AutoMap()
  @IsDefined()
  @IsString()
  @IsNotEmpty()
  email: string;

  @AutoMap()
  @IsDefined()
  @IsString()
  @IsNotEmpty()
  password: string;

  @AutoMap()
  @IsDefined()
  @IsString()
  @IsNotEmpty()
  phone: string;

  @AutoMap()
  @IsDefined()
  @IsString()
  @IsNotEmpty()
  homeApp: string;

  @AutoMap()
  @IsDefined()
  @IsString()
  @IsNotEmpty()
  timezone: string;

  @AutoMap()
  @IsDefined()
  @IsString()
  @IsNotEmpty()
  locale: string;

  @AutoMap()
  @IsDefined()
  @IsString()
  @IsNotEmpty()
  preferredAccount: string;
}
